import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, Text, TextInput } from '@mantine/core';
import { type UseFormReturnType } from '@mantine/form';

import { useEditPage } from '../../../../api';
import { useEditPageForm } from '../../../../hooks';
import type { EditInstPageData, EditTgPageData, InstPage, TgPage } from '../../../../types';

import { DepartmentsSelect } from '@/components/Selects';

type Props = {
  platform: 'telegram' | 'instagram';
  page: TgPage | InstPage;
};

export const EditPageModal = NiceModal.create(({ platform, page }: Props) => {
  const modal = useModal();
  const form = useEditPageForm({
    name: page.name,
    username: page.username,
    ...(platform === 'telegram' && { phone: (page as TgPage).phone ?? '' }),
    ...(platform === 'instagram' && { department: (page as InstPage).department }),
  });
  const { mutate, isLoading } = useEditPage({ platform });

  function handleSubmit(data: EditTgPageData | EditInstPageData) {
    mutate(
      {
        platform,
        id: page._id,
        data,
      },
      {
        onSuccess: modal.remove,
      }
    );
  }

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Edit Page"
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Text mt="sm" mb="xs" size="sm">
          Name
        </Text>
        <TextInput required placeholder="Page name" mb="xl" {...form.getInputProps('name')} />
        <Text mt="sm" mb="xs" size="sm">
          Username
        </Text>
        <TextInput
          required
          placeholder="Page username"
          mb="sm"
          {...form.getInputProps('username')}
        />
        {platform === 'telegram' && (
          <>
            <Text mt="sm" mb="xs" size="sm">
              Номер
            </Text>
            <TextInput placeholder="Номер телефона" mb="xl" {...form.getInputProps('phone')} />
          </>
        )}
        {platform === 'instagram' && (
          <>
            <Text mt="sm" mb="xs" size="sm">
              Department
            </Text>
            <DepartmentsSelect
              value={(form.values as EditInstPageData).department}
              onSelect={(department) =>
                (form as UseFormReturnType<EditInstPageData>).setFieldValue(
                  'department',
                  department
                )
              }
            />
          </>
        )}
        <Group justify="right" mt="xl">
          <Button loading={isLoading} type="submit">
            Save
          </Button>
        </Group>
      </form>
    </Modal>
  );
});
